import { IconButton } from './IconButton';

export default IconButton;
